import React from 'react'
import { Box } from '@mui/material'
import { MasterManagementToolSelect } from 'shared/ui'
import { useMasterManagementTools, useMasterTitle } from './utility'

export function MasterManagement({
  masterId,
  onComponentSelect,
}: {
  masterId: string
  onComponentSelect?: (title?: string) => void
}) {
  const title = useMasterTitle(masterId)
  const components = useMasterManagementTools(masterId)
  return (
    <Box>
      <Box>
        <strong>{title}</strong>
      </Box>
      <Box padding="10px">
        <MasterManagementToolSelect
          components={components}
          onComponentSelect={onComponentSelect}
        />
      </Box>
    </Box>
  )
}
